import { render, staticRenderFns } from "./makeMoneyPopup.vue?vue&type=template&id=247cb573&scoped=true"
import script from "./makeMoneyPopup.vue?vue&type=script&lang=js"
export * from "./makeMoneyPopup.vue?vue&type=script&lang=js"
import style0 from "./makeMoneyPopup.vue?vue&type=style&index=0&id=247cb573&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cb573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247cb573')) {
      api.createRecord('247cb573', component.options)
    } else {
      api.reload('247cb573', component.options)
    }
    module.hot.accept("./makeMoneyPopup.vue?vue&type=template&id=247cb573&scoped=true", function () {
      api.rerender('247cb573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/makeMoneyPopup.vue"
export default component.exports